import {useEffect, useState} from 'react';
import {useLDClient} from 'gatsby-plugin-launchdarkly';

/**
 * Returns a boolean indicating whether the LaunchDarkly client is ready,
 * meaning it has received an initial set of flag values.
 *
 * This is useful for components that render differently based on a flag value.
 */
export function useLaunchDarkly() {
  const ldClient = useLDClient();
  // If the client exists, then it's already been initialized with flags.
  const [isReady, setIsReady] = useState(Boolean(ldClient));

  useEffect(() => {
    // If there's no LaunchDarkly client yet, return.
    if (!ldClient)
      return;

    // If the client is defined, then it is ready.
    setIsReady(true);
  }, [ldClient]);

  return isReady;
}
